import * as React from "react";
import { useIntl } from "@grandvisionhq/state";
import StoreFacilities from "./StoreFacilities.js";
const StoreFacilitiesContainer = ({ facilities, ...rest }) => {
  const { getLabel } = useIntl();
  const labels = React.useMemo(
    () => ({
      title: getLabel("stores.page.details.facilities.title")
    }),
    [getLabel]
  );
  return /* @__PURE__ */ React.createElement(StoreFacilities, { labels, facilities, ...rest });
};
export {
  StoreFacilitiesContainer as default
};
//# sourceMappingURL=StoreFacilitiesContainer.js.map
